import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { dateFormatOptions } from '../../../../../app/core/constants/constants';
import {
  CustomerTrainingService,
  CustomerTrainingMaterial,
  CustomerTrainingDataObject,
} from 'src/app/core/services/customer-training.service';
import { MatSelectChange } from '@angular/material/select';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-customer-training',
  templateUrl: './customer-training.component.html',
  styleUrls: ['./customer-training.component.scss'],
  standalone: false,
})
export class CustomerTrainingComponent implements OnInit {
  files: CustomerTrainingMaterial[] = [];

  videos: CustomerTrainingMaterial[] = [];

  locations: { id: number; location: string }[] = [];

  selectControl = new UntypedFormControl('');

  selectOptions = [];

  readonly columns: string[] = ['title', 'date', 'path'];

  selectedVideo: CustomerTrainingMaterial;

  constructor(
    private dialogRef: MatDialogRef<CustomerTrainingComponent>,
    public customerTrainingService: CustomerTrainingService,
    @Inject(MAT_DIALOG_DATA) public data: CustomerTrainingData,
  ) {}

  ngOnInit(): void {
    this.locations = this.customerTrainingService.customerTrainingLocations;
    this.locations.push({
      id: this.locations.length,
      location: 'show-all',
    });
    this.selectOptions = this.customerTrainingService.selectOptions;

    const currentLocation = this.customerTrainingService.getLocation(this.data.currentPath);

    const existCurrentLocation = this.customerTrainingService.checkDataExistsForCurrentLocation(currentLocation);

    if (!existCurrentLocation) {
      this.selectControl.setValue('show-all');
      const data: CustomerTrainingDataObject = this.customerTrainingService.getAllCustomerTraining;
      this.files = data.files;
      this.videos = data.videos;
    }

    if (existCurrentLocation) {
      this.selectControl.setValue(currentLocation);
      const data: CustomerTrainingDataObject =
        this.customerTrainingService.customerTrainingDataByLocation(currentLocation);
      this.files = data.files ?? [];
      this.videos = data.videos ?? [];
    }
    this.refreshSelectedVideo();
  }

  formatName(rawName: string): string {
    return rawName
      .replace(/^.*[\\\/]/, '')
      .replace(/\.[^/.]+$/, '')
      .replaceAll('_', ' ');
  }

  formatDate(date: string): string {
    const dateParsed = new Date(date);
    return dateParsed.toLocaleDateString('en-US', dateFormatOptions);
  }

  changeSelectedVideo(video): void {
    this.selectedVideo = {
      name: video.name,
      path: video.path,
      date: video.date,
    };
  }

  onChangeGroupSelect(event: MatSelectChange) {
    const selectedOption = this.selectControl.value as string;
    if (selectedOption === 'show-all') {
      const data: CustomerTrainingDataObject = this.customerTrainingService.getAllCustomerTraining;
      this.files = data.files;
      this.videos = data.videos;
    }
    if (selectedOption !== 'show-all') {
      const data = this.customerTrainingService.customerTrainingDataByLocation(selectedOption);
      this.files = data.files ?? [];
      this.videos = data.videos ?? [];
    }
    this.refreshSelectedVideo();
  }

  close() {
    this.dialogRef.close();
  }

  private refreshSelectedVideo() {
    if (this.videos.length > 0) {
      this.selectedVideo = {
        name: this.videos[0].name,
        path: this.videos[0].path,
        date: this.videos[0].date,
      };
    }
  }
}

interface CustomerTrainingData {
  currentPath: string;
}
